import * as React from "react";

import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { ProjectsEmpty } from "../../../../config/view_const/projects";
import { Project } from "../../../../domain/model/project";
import BtnLinkCorporateSmall from "../../../common/atom/btn/btn_link_corporate_small";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import ProfileRightBtnWrapper from "../../../common/atom/wrapper/profile_right_btn_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import EmptyData from "../../../common/organism/empty_data";
import { TBreadcrumbItem } from "../../../type/common";
import ClientScoutCustomerMainScoutSecondForm from "./client_scout_customer_second/client_scout_customer_main_scout_second_form";

interface IProps {
  projects: Project[];
  handleNextStep: (values: any) => void;
  handlePreviousStep: (values: any) => void;
}

const ClientScoutCustomerSecondComponent: React.FC<IProps> = (props) => {
  const { projects, handleNextStep, handlePreviousStep } = props;

  const clientScoutCustomerListMainScoutSecondParams = {
    projects,
    handlePreviousStep,
  };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    { text: `プロに提示する案件を選択してください。` },
  ];

  return (
    <React.Fragment>
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
        <ProfileRightBtnWrapper>
          <BtnLinkCorporateSmall to={"/client/project/create/new"}>
            案件を作成する
          </BtnLinkCorporateSmall>
        </ProfileRightBtnWrapper>

        {projects && projects.length === 0 && (
          <EmptyData
            main={ProjectsEmpty.projectsForClientScoutMain}
            description={ProjectsEmpty.projectsForClientScoutDescription}
          />
        )}
        {projects && projects.length > 0 && (
          <ClientScoutCustomerMainScoutSecondForm
            {...clientScoutCustomerListMainScoutSecondParams}
            onSubmit={handleNextStep}
          />
        )}
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientScoutCustomerSecondComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer_second.tsx